import React from 'react';
import { MinusIcon } from 'lucide-react';
import { Section } from './Section';
import { painPoints } from '../data/painPoints';
export function PainGrid() {
  return <Section background="paper" labelledBy="pain-heading" data-id="element-209" data-mp="1uop2bhjzd0t3">
      <h2 id="pain-heading" className="mx-auto max-w-3xl text-center font-serif text-[27px] font-semibold leading-[1.15] text-ink sm:text-3xl lg:text-[40px]" data-id="element-210" data-mp="1un5kvnml8jpq">
        If you teach real bodies, at least one of these will sound familiar:
      </h2>

      <ul className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-211" data-mp="1goo0nzvw5pck">
        {painPoints.map(point => <li key={point} className="flex items-start gap-3.5 rounded-2xl border border-sage/15 bg-white p-5 shadow-card sm:p-6" data-id="element-212" data-mp="1bqvy8bxmeku4">
            <MinusIcon className="mt-0.5 h-5 w-5 shrink-0 text-ink-muted" strokeWidth={2} aria-hidden="true" data-id="element-213" data-mp="363vnkwrsytel" />
            <p className="font-sans text-[15px] leading-[1.6] text-ink-soft sm:text-base" data-id="element-214" data-mp="3231uzq3f0qfd">
              {point}
            </p>
          </li>)}
      </ul>

      <p className="mx-auto mt-12 max-w-2xl text-center font-serif text-2xl font-medium leading-snug text-ink sm:text-[28px]" data-id="element-215" data-mp="3l8g69bot024l">
        What if every one of these already had an answer — written down, one page each, findable
        while someone is standing in front of you?
      </p>
    </Section>;
}